import {
  Chip,
  createStyles,
  FormControl,
  IconButton,
  Link,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
} from '@material-ui/core';
import React, { useState } from 'react';
import { commonStyles } from '../../../../../../styles/common';
import BlockIcon from '@material-ui/icons/Block';
import { capitalizeFirstLetter } from '../../../../../home/allAssets/util';
import ConfirmationPopup from '../../PlannerQEBot/components/ConfirmationPopup';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
interface Project {
  instanceid: string;
  statusutc: string;
  statusmsg: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    ...commonStyles(theme),
    table: {
      minWidth: 650,
    },
    tableHead: {
      backgroundColor: theme.palette.table.headerBackground + ' !important',
    },
    tableHeadCell: {
      color: theme.palette.text.secondary,
      fontWeight: 600,
    },
    chip: {
      backgroundColor: theme.palette.colors.lightGreen,
      padding: `${theme.spacing(0.5)}px ${theme.spacing(2)}px`,
    },
    checkIcon: {
      color: theme.palette.successText,
    },
    blockIcon: {
      color: theme.palette.errorText,
    },
    infoIcon: {
      color: theme.palette.warningText,
    },
    dropdownACFormat: {
      width: '120px',
      padding: '12px',
    },
  }),
);

const ReposTable = ({ isToolAdmin, projects, repos, onChange }: any) => {
  const classes = useStyles();

  enum status {
    ENABLED = 'enabled',
    WORKING = 'working',
    DISABLED = 'disabled',
  }

  const emptyPopupState = {
    open: false,
    popupContent: {
      title: '',
      description: '',
      subDescription: '',
      enabled: false,
    },
    onConfirm: () => {},
    onClose: () => {},
  };

  const [confirmationPopup, setConfirmationPopup] = useState({
    ...emptyPopupState,
  });

  const handleCloseConfirmationPopup = () => {
    setConfirmationPopup({ ...emptyPopupState });
  };

  const handleConfirmEnablePopup = (project: Project) => {
    onChange(project);
    handleCloseConfirmationPopup();
  };

  const handleConfirmationPopup = (project: Project) => {
    const enabled = project?.statusmsg
      ? project?.statusmsg?.toLowerCase() === status.ENABLED
      : false;
    setConfirmationPopup({
      open: true,
      popupContent: {
        title: enabled ? 'Disable - CodeQ Agent' : 'Enable - CodeQ Agent',
        description: enabled
          ? 'Are you sure you want to disable this service?'
          : 'Are you sure you want to enable this service?',
        subDescription: enabled
          ? 'This feature will be disabled from the project.'
          : 'This feature will be enabled from the project.',

        enabled: enabled,
      },
      onConfirm: () => {
        handleConfirmEnablePopup(project);
      },
      onClose: () => {
        handleCloseConfirmationPopup();
      },
    });
  };

  return (
    <>
      {repos && repos?.length > 0 ? (
        <TableContainer component={Paper}>
          <Table
            size="small"
            className={classes.table}
            aria-label="a dense table"
          >
            <TableHead>
              <TableRow classes={{ root: classes.tableHead }}>
                <TableCell>
                  <Typography
                    classes={{ root: classes.tableHeadCell }}
                    variant="subtitle2"
                  >
                    SonarQube Project Key
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    classes={{ root: classes.tableHeadCell }}
                    variant="subtitle2"
                  >
                    Repo Name
                  </Typography>
                </TableCell>
                {/* <TableCell>
                  <Typography
                    classes={{ root: classes.tableHeadCell }}
                    variant="subtitle2"
                  >
                    Last Scanned
                  </Typography>
                </TableCell> */}
                <TableCell>
                  <Typography
                    classes={{ root: classes.tableHeadCell }}
                    variant="subtitle2"
                  >
                    Status
                  </Typography>
                </TableCell>
                {isToolAdmin && (
                  <TableCell>
                    <Typography
                      classes={{ root: classes.tableHeadCell }}
                      variant="subtitle2"
                    >
                      Enable/Disable
                    </Typography>
                  </TableCell>
                )}
              </TableRow>
            </TableHead>

            <TableBody>
              {repos?.map((repo: any) => {
                const repoDetail =
                  projects?.length !== 0 &&
                  projects?.find((detail: any) => {
                    return detail?.instanceid === repo?.SonarQubeProjectKey;
                  });
                return (
                  <TableRow key={repo?.id}>
                    <TableCell>
                      <Typography variant="subtitle2">
                        {repo?.SonarQubeProjectKey}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="subtitle2">
                        {/* {projectDetail?.projectid || instanceid} */}
                        {repo?.Name}
                      </Typography>
                    </TableCell>
                    {/* <TableCell>
                      <Typography variant="subtitle2">-</Typography>
                    </TableCell> */}
                    <TableCell>
                      <Typography variant="subtitle2">
                        {/* {JSON.stringify(project.enabled)} */}
                        <Chip
                          classes={{ root: classes.chip }}
                          label={
                            repoDetail?.statusmsg
                              ? capitalizeFirstLetter(repoDetail?.statusmsg)
                              : capitalizeFirstLetter(status.DISABLED)
                          }
                          icon={
                            repoDetail?.statusmsg ? (
                              repoDetail?.statusmsg?.toLowerCase() ===
                              status.ENABLED ? (
                                <CheckCircleIcon
                                  classes={{ root: classes.checkIcon }}
                                />
                              ) : repoDetail?.statusmsg?.toLowerCase() ===
                                status.WORKING ? (
                                <InfoOutlinedIcon
                                  classes={{ root: classes.infoIcon }}
                                />
                              ) : (
                                <BlockIcon
                                  classes={{ root: classes.blockIcon }}
                                />
                              )
                            ) : (
                              <BlockIcon
                                classes={{ root: classes.blockIcon }}
                              />
                            )
                          }
                          size="small"
                        />
                      </Typography>
                    </TableCell>
                    {isToolAdmin && (
                      <TableCell>
                        <Switch
                          checked={
                            repoDetail?.statusmsg
                              ? repoDetail?.statusmsg?.toLowerCase() ===
                                status.ENABLED
                              : false
                          }
                          onClick={() =>
                            handleConfirmationPopup(
                              repoDetail === undefined
                                ? repo
                                : { ...repo, ...repoDetail },
                            )
                          }
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography>No repos found.</Typography>
      )}
      {confirmationPopup?.open && <ConfirmationPopup {...confirmationPopup} />}
    </>
  );
};

export default ReposTable;
